// React
import { FunctionComponent, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// Components
import VestaPage from "../../components/VestaPage/VestaPage";
import ScheduleCategoryPanel from "./Panel/ScheduleCategoryPanel";
import { AbsenceCalendar } from '@fyrstain/fhir-front-library';
import EmptyMonthCalendar from "./EmptyMonthCalendar";
// Services
import CalendarService, { type Group, type Item } from "../../services/CalendarFHIRService";
// Style
import './style.css';

const VestaCalendar: FunctionComponent = () => {

 /////////////////////////////////
 //        CONSTANTS           //
 /////////////////////////////////

    const [groups, setGroups] = useState<Group[]>([]);

    const [items, setItems] = useState<Item[]>([]);

    const [status, setStatus] = useState<"loading" | "ready" | "error">("loading");

    const [calendarService] = useState(() => new CalendarService());
    const { t } = useTranslation();

  ////////////////////////////////
  //         FUNCTIONS          //
  ////////////////////////////////

    /**
    * Loading Practitioner by PractitionerRole
    */
    const loadSchedule = useCallback(async (agents: Group[]) => {
        setItems([]);
        const freshItems = await calendarService.loadSchedule(agents);
        setItems(freshItems);
    }, [calendarService]);

    const loadPractitionerRoles = useCallback(async () => {
        setStatus("loading");
        const result = await calendarService.loadPractitionerRolesResult();
        setGroups(result.groups);
        if (result.error) {
            setItems([]);
            setStatus("error");
            return;
        }
        if (result.groups.length > 0) {
            await loadSchedule(result.groups);
        } else {
            setItems([]);
        }
        setStatus("ready");
    }, [calendarService, loadSchedule]);

    useEffect(() => {
        void loadPractitionerRoles();
    }, [loadPractitionerRoles]);

  ////////////////////////////////
  //            CONTENT         //
  ////////////////////////////////
  
    return (
        <VestaPage titleKey='title.page' loading={false} needsLogin={true}>
            <>
                <div className="schedule-container">
                    {status === "ready" && groups.length > 0 ? (
                        <AbsenceCalendar groups={groups} items={items} language={t} />
                    ) : (
                        <EmptyMonthCalendar status={status} onRetry={loadPractitionerRoles} />
                    )}
                </div>
                <ScheduleCategoryPanel />
            </>
        </VestaPage>
    );
};

export default VestaCalendar;
